import path from 'node:path';
import { yieldForBridgeInteractivePriority } from '../../files/browser/in-flight.js';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { CliSqliteInterrupted } from '../../sqlite/code-nav-cache/database.js';
import { withFileIndexSqliteLock } from './file-index-sqlite-lock.js';
import { collectWorkspacePathsAsync } from './collect-workspace-paths.js';
import { persistFileIndexPathsAsync } from './persist-file-index.js';

function assertNotShutdown(): void {
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
}

/**
 * Walk the workspace and replace `file_index_child_path` rows for this parent path in one transaction.
 */
export async function buildFileIndex(cwd: string): Promise<{ pathCount: number }> {
  return buildFileIndexAsync(cwd);
}

/**
 * Async walk (yields during crawl) then a short SQLite transaction so Ctrl+C and bridge `close()` are not
 * blocked by a long synchronous filesystem crawl on the main thread.
 */
export async function buildFileIndexAsync(cwd: string): Promise<{ pathCount: number }> {
  const resolved = path.resolve(cwd);
  await yieldForBridgeInteractivePriority();
  assertNotShutdown();
  const paths = await collectWorkspacePathsAsync(resolved);
  await yieldForBridgeInteractivePriority();
  assertNotShutdown();
  return await withFileIndexSqliteLock(async () => {
    const pathCount = await persistFileIndexPathsAsync(resolved, paths);
    return { pathCount };
  });
}
